import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, type ForensicDetail } from '../api';

export function ForensicDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [r, setR] = useState<ForensicDetail | null>(null);

  useEffect(() => {
    if (!id) return;
    api.forensicDetail(id).then((d) => setR(d.report));
  }, [id]);

  if (!r) return <p className="muted">Loading…</p>;

  return (
    <>
      <div className="card">
        <h2>Forensic report</h2>
        <dl className="kv">
          <dt>Reported domain</dt><dd>{r.reported_domain ?? '—'}</dd>
          <dt>Source IP</dt><dd>{r.source_ip ?? '—'}</dd>
          <dt>Auth failure</dt><dd>{r.auth_failure ?? '—'}</dd>
          <dt>Identity alignment</dt><dd>{r.identity_alignment ?? '—'}</dd>
          <dt>Delivery result</dt><dd>{r.delivery_result ?? '—'}</dd>
          <dt>Original Mail-From</dt><dd>{r.original_mail_from ?? '—'}</dd>
          <dt>Original Rcpt-To</dt><dd>{r.original_rcpt_to ?? '—'}</dd>
          <dt>Reporting MTA</dt><dd>{r.reporting_mta ?? '—'}</dd>
          <dt>User-Agent</dt><dd>{r.user_agent ?? '—'}</dd>
          <dt>Arrival</dt><dd>{r.arrival_date ?? '—'}</dd>
          <dt>Failing Message-ID</dt><dd>{r.failing_message_id ?? '—'}</dd>
          <dt>Failing subject</dt><dd>{r.subject ?? '—'}</dd>
          <dt>SPF DNS</dt><dd>{r.spf_dns ?? '—'}</dd>
          <dt>DKIM domain / selector</dt>
          <dd>
            {(r.dkim_domain ?? '—') + (r.dkim_selector ? ` / ${r.dkim_selector}` : '')}
          </dd>
        </dl>
      </div>
      <div className="card">
        <h2>Authentication-Results</h2>
        <pre>{r.authentication_results ?? '(none)'}</pre>
      </div>
      <div className="card">
        <h2>Raw report fields</h2>
        <pre>{JSON.stringify(r.raw_headers, null, 2)}</pre>
      </div>
    </>
  );
}
